<pureui-svg
    [svg]="'info-circle.svg'"
    [height]="13"
    [ngbTooltip]="tooltipContent"
    container="body"
    placement="right"
></pureui-svg>
